module.exports = __webpack_public_path__ + "manageStatic/img/logo_wapen.12f7b92e.png";